export default __webpack_public_path__ + "media/images/features/local_delivery/background-d24ded4a8a6c1b0a04c555158be36ddd.jpg";